import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { CategoriaProducto } from '../../categoria-producto/categoria-producto.model';
import { BackendService } from '../../../core/backend.service';
import { Observable } from 'rxjs';
import { SecurityService } from '../../../security/security.service';
import { ActivatedRoute } from '@angular/router';
import { Producto } from '../../producto.model';
import { SnackService } from '../../../shared-services/snack.service';
import { FormValidatorService } from '../../../shared-services/form-validator.service';
import { NgForm } from '@angular/forms';
import { ProductoListComponent } from '../../producto-list/producto-list.component';
import { NavigationService } from '../../../shared-services/navigation.service';
import { ProductosBuscados } from '../categoria-producto-add-massive/productosBuscados.models';

@Component({
  selector: 'app-destacado-producto-add-massive',
  templateUrl: './destacado-producto-add-massive.component.html',
  styleUrls: ['./destacado-producto-add-massive.component.scss']
})
export class DestacadoProductoAddMassiveComponent implements OnInit {
  @ViewChild('form') public productoForm: NgForm;
  @ViewChild('searchInput') searchInput: ElementRef;
  paisElegido: string;
  productos: Observable<ProductosBuscados[]>;
  opcionesPais: string[] =  ["ARGENTINA", "CHILE"];
  prodDestacados: ProductosBuscados[] = [];
  destacado = false;
  
  constructor(
    private snackService: SnackService,
    private backendService: BackendService,
  ) {}

  ngOnInit () {

  }

  async validateForm() {

    if (this.prodDestacados.length == 0) {
      this.snackService.error("Por favor, cargue al menos un producto.");
      return;
    }
    await this.guardar();
  }

  compareFn (c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  async guardar() {
    try {
      this.snackService.spinner(true);
      await this.backendService.update(ProductosBuscados.path + "update-destacados-producto-massive/" + this.paisElegido, this.prodDestacados).then(a=>{
        this.snackService.success("Se cargaron los productos destacados correctamente");
      })
    } catch (ex) {
      this.snackService.error("Falló la carga de productos destacados");
    } finally {
      this.snackService.spinner(false);
    }
  }

  back () {
    this.paisElegido = '';
  }

  async getProductos(pais: string) {
    this.productos = await this.backendService.get(ProductosBuscados, ProductosBuscados.path + "all-producto-pais/" + pais, null);
    this.getProductosDestacados(pais);
  }

  async getProductosDestacados(pais: string) {
    this.prodDestacados = await this.backendService.get(ProductosBuscados, ProductosBuscados.path + "destacados/" + pais, null).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/carga-masiva/destacado-producto-add-massive/destacado-producto-add-massive.component.ts